<ng-container *ngIf="active; else defaultTpl">
  <ng-content select="[elmButtonConfirmActive]"></ng-content>
</ng-container>

<ng-template #defaultTpl> <ng-content select="[elmButtonConfirmDefault]"></ng-content> </ng-template>
